module.exports = __webpack_public_path__ + "img/pdfHeader.3d1b038f.png";